import { render, staticRenderFns } from "./LinkBlock.vue?vue&type=template&id=0ee39777"
import script from "./LinkBlock.vue?vue&type=script&lang=js"
export * from "./LinkBlock.vue?vue&type=script&lang=js"
import style0 from "./LinkBlock.vue?vue&type=style&index=0&id=0ee39777&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports